import Vue from 'vue';
import SvgIcon from '@/components/SvgIcon';

// register globally
Vue.component('svg-icon', SvgIcon);

const requireAll = requireContext => requireContext.keys().map(requireContext);
const req = require.context('@/icons/svg', false, /\.svg$/);
requireAll(req);
